module.exports = __webpack_public_path__ + "DiplomainGameDesignProduction-834a0eb2.webp";